import * as React from "react";
import HoldUtilHeader from "../../generic/holdUtilHeader";
import HoldEqSmallcaseRowDsk from "./holdEqSmallcaseRowDsk";
import HoldEqSmallcaseRowMob from "./holdEqSmallcaseRowMob";
import DeviceContext from "../../../../service/indentifyDevice";
import Sort, { eSortState, sort } from "../../../../generic/sort";
import { SearchHighLight } from "../../../../service/generic/searchHighlight";
import NoDataContainer from "../../../../generic/noDataContainer";
import { initWS } from "../../../../service/edelWebSockets/wsCallbacks";
import { ISocketSubscribeReq } from "../../../../types/components/edelSockets/edelSocketTypes";
import { edelSocketQuoteReq } from "../../../../service/edelWebSockets/wsInit";
import { getAccData } from "../../../../service/login/loginService";
import { genHshObj } from "../../../../utils/hashObj";

if (DeviceContext().isDesktop) {
  require("../../../../../assets/scss/components/toc/holdings/holdTables/holdTableDsk.scss");
} else if (DeviceContext().isTablet) {
  require("../../../../../assets/scss/components/toc/holdings/holdTables/holdTableTab.scss");
} else {
  require("../../../../../assets/scss/components/toc/holdings/holdTables/holdTableMob.scss");
}

export interface IHoldEqSmallcaseTableProps {
  data: Array<any>;
}

export interface IHoldEqSmallcaseTableState {
  initialData: Array<any>;
  filteredData: Array<Array<any>>;
  tableData: Array<Array<any>>;
  sortedColumnState: { colName: string | null; sortState: eSortState };
}

const heading = {
  stockName: "Name",
  shares: "Qty",
  ltp: "LTP/Close",
  averagePrice: "Holding Value",
};

class HoldEqSmallcaseTable extends React.Component<
  IHoldEqSmallcaseTableProps,
  IHoldEqSmallcaseTableState
> {
  state: IHoldEqSmallcaseTableState = {
    initialData: this.props.data,
    filteredData: [this.props.data],
    tableData: [this.props.data],
    sortedColumnState: { colName: null, sortState: eSortState.ASC },
  };

  filteredHash: { [x: string]: [number, number] } = {}; // hash object for filteredData
  tableHash: { [x: string]: [number, number] } = {}; // hash object for tableData

  parsePropData = () => {
    // deepcopy for searching, otherwise the changes happen through reference in SearchHighLight
    return this.state.initialData.map((row) => ({ ...row }));
  };

  componentDidMount() {
    initWS<ISocketSubscribeReq>(
      edelSocketQuoteReq("quote3", {
        vendID: "EDEL",
        vendToken: "",
        userID: getAccData("userID"),
        accType: getAccData("accTyp"),
        symbols: this.props.data.map((data) => ({
          symbol: data.nsestreamingSym,
        })),
      }),
      this.socketMessages
    );

    // parse data first to move hdgVl to first level
    const data = this.parsePropData();

    this.setState({
      filteredData: [data],
      tableData: [data],
      initialData: data,
    });

    this.filteredHash = genHshObj([data], "nsestreamingSym");
    this.tableHash = this.filteredHash;
  }

  componentWillUnmount = () => {
    initWS<ISocketSubscribeReq>(
      edelSocketQuoteReq(
        "quote3",
        {
          vendID: "EDEL",
          vendToken: "",
          userID: getAccData("userID"),
          accType: getAccData("accTyp"),
          symbols: this.props.data.map((data) => ({ symbol: data.sym })),
        },
        "unsubscribe"
      ),
      () => {}
    );
  };

  onSort = (
    data: Array<Array<any>>,
    sortState: eSortState,
    colName: string
  ) => {
    this.setState({
      sortedColumnState: { colName, sortState },
      tableData: data,
    });
    this.tableHash = genHshObj(data, "nsestreamingSym");
  };

  sortAfterFilter = (groupedData: Array<Array<any>>) => {
    // if some column was sorted earlier, then sort that again
    if (this.state.sortedColumnState.colName) {
      // copy grouped data, because it will change after sorting
      // filtered data will also change with groupedData
      const copyGroupedData = groupedData.map((group) =>
        group.map((data) => data)
      );

      sort(
        copyGroupedData,
        this.state.sortedColumnState.sortState,
        this.state.sortedColumnState.colName,
        this.onSort
      );
    }
  };

  handleSearch = (filteredData: Array<Array<any>>, sText?: string) => {
    // set filtered data in the beginning because this will be used while sorting
    // we don't want the <b> tag while sorting
    this.setState({ filteredData });

    if (sText) {
      const SearchText: string = sText.toLowerCase();
      const searchKey: string = "stockName";

      // highlight the rows
      filteredData[0] = filteredData[0].map(({ ...row }: any) => ({
        ...row,
        [searchKey]: SearchHighLight(row[searchKey], SearchText),
      }));
    }

    this.setState({ tableData: filteredData });
    this.filteredHash = genHshObj(filteredData, "nsestreamingSym");
    this.tableHash = this.filteredHash;

    this.sortAfterFilter(filteredData);
  };

  socketMessages = (res: any) => {
    if (typeof res === "string") {
      // success
      const { response } = JSON.parse(res);
      const sym = response.data.z3;
      const ltp = response.data.a9;

      const filteredIndex = this.filteredHash[sym];
      const tableIndex = this.tableHash[sym];

      if (tableIndex)
        console.log(
          ltp,
          sym,
          this.tableHash,
          this.state.tableData[tableIndex[0]][tableIndex[1]]
        );

      if (
        filteredIndex &&
        tableIndex &&
        this.state.tableData[tableIndex[0]][tableIndex[1]] &&
        this.state.tableData[tableIndex[0]][tableIndex[1]].ltp !== ltp
      ) {
        // console.log(this.state.tableData[tableIndex[0]][tableIndex[1]], ltp);
        const filteredDataTemp = this.state.filteredData;
        const tableDataTemp = this.state.tableData;

        let row = {
          ...this.state.filteredData[filteredIndex[0]][filteredIndex[1]],
        };
        this.updateRowOnStream(row, ltp);
        filteredDataTemp[filteredIndex[0]][filteredIndex[1]] = row;

        row = { ...this.state.tableData[tableIndex[0]][tableIndex[1]] };
        this.updateRowOnStream(row, ltp);
        tableDataTemp[tableIndex[0]][tableIndex[1]] = row;

        this.setState({
          filteredData: filteredDataTemp,
          tableData: tableDataTemp,
        });
      }
    } else {
      //console.log(res.type);
    }
  };

  updateRowOnStream(row: any, ltp: string) {
    row.ltp = ltp;
    row.averagePrice = +ltp * row.shares;
  }

  render() {
    return (
      <>
        <HoldUtilHeader
          data={[this.state.initialData || []]}
          searchKey="stockName"
          onDataFilter={this.handleSearch}
          onSearchClick={() => {}}
        />

        <div className="hold_eq_smallcase_table_dsk hold_table">
          {!DeviceContext().isMobile && (
            <ul className="hdr_row">
              <li>
                <div className="col stockName">
                  <Sort
                    sortList={this.state.filteredData}
                    sortedColName={this.state.sortedColumnState.colName}
                    sortKey="stockName"
                    onSort={this.onSort}
                    colName={heading.stockName}
                  />
                </div>
                <div className="col shares w_80">{heading.shares}</div>
                <div className="col ltp w_80">{heading.ltp}</div>
                <div className="col averagePrice w_90">
                  <Sort
                    sortList={this.state.filteredData}
                    sortedColName={this.state.sortedColumnState.colName}
                    sortKey="averagePrice"
                    onSort={this.onSort}
                    colName={heading.averagePrice}
                  />
                </div>
              </li>
            </ul>
          )}

          {/* If data is not there in array, then show no data container */}
          {this.state.tableData[0].length ? (
            <div className="hold_scroll_cont_sc">
              <ul>
                {this.state.tableData[0].map((row, index) => (
                  <React.Fragment key={index}>
                    {!DeviceContext().isMobile ? (
                      <HoldEqSmallcaseRowDsk rowData={row} />
                    ) : (
                      <HoldEqSmallcaseRowMob rowData={row} />
                    )}
                  </React.Fragment>
                ))}
              </ul>
            </div>
          ) : (
            <NoDataContainer txtHeading="No results found" />
          )}
        </div>
      </>
    );
  }
}

export default HoldEqSmallcaseTable;
